export let rolesTableLabels = [
  {
    label: '角色名',
    value: 'displayName'
  },
  {
    label: '用户数量（个）',
    value: 'countUser'
  }
]
